'use client';
import * as styles from './styles.css';
export { styles as horizontalScrollStyles };
import _extends from '@babel/runtime/helpers/esm/extends';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React, { useRef, useEffect, forwardRef, useState, useLayoutEffect } from 'react';
import { IconButton } from '@paypalcorp/pp-react-icon-button';
import { ArrowRightIcon, ArrowLeftIcon } from '@paypalcorp/pp-react-icons';
import { cx, remToPx, devWarning } from '@paypalcorp/pp-react-utils';
import { tokens, breakpoints } from '@paypalcorp/pp-react-theme';

var peekWidth = tokens.space[200];
var mobileItemMargin = tokens.space[150];
var itemMargin = tokens.space[200];
function getValueOfToken(token) {
  var variableName = token.slice(4, -1);
  var themeElement = document.querySelector('.ppui-theme');
  var computedStyle = window.getComputedStyle(themeElement);
  var value = computedStyle.getPropertyValue(variableName).slice(0, -3); // removing rem from the string
  return parseFloat(value);
}
var getFlexBasisItems = function (props) {
  var items = props.items,
    numOfVisibleItems = props.numOfVisibleItems,
    hasFixedSizeItems = props.hasFixedSizeItems,
    isMobileBreakpoint = props.isMobileBreakpoint;
  if (hasFixedSizeItems) {
    return {
      flexBasis: 'auto'
    };
  }
  if (isMobileBreakpoint) {
    var peekOffset = items.length === numOfVisibleItems ? null : "calc(".concat(peekWidth, " + ").concat(mobileItemMargin, " / 2)");
    var availableViewSpace = peekOffset ? "calc(100% - ".concat(peekOffset, ")") : '100%';
    return {
      flexBasis: "calc(".concat(availableViewSpace, " / ").concat(numOfVisibleItems, " - ").concat(mobileItemMargin, ")")
    };
  }
  return {
    flexBasis: "calc(100% / ".concat(numOfVisibleItems, " - ").concat(itemMargin, ")")
  };
};
var getContainerWidth = function (pageWidth) {
  var hasFixedSizeItems = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return hasFixedSizeItems ? {
    width: "".concat(pageWidth, "px")
  } : {};
};

var _excluded$2 = ["items", "numOfVisibleItems", "renderItem", "className", "itemClassName", "hasFixedSizeItems", "onItemListScroll", "onInit"];
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike) { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var HorizontalScrollMobile = function (_ref) {
  var _ref$items = _ref.items,
    items = _ref$items === void 0 ? [] : _ref$items,
    numOfVisibleItems = _ref.numOfVisibleItems,
    renderItem = _ref.renderItem,
    className = _ref.className,
    itemClassName = _ref.itemClassName,
    hasFixedSizeItems = _ref.hasFixedSizeItems,
    onItemListScroll = _ref.onItemListScroll,
    onInit = _ref.onInit,
    rest = _objectWithoutProperties(_ref, _excluded$2);
  /* istanbul ignore next */
  if (!renderItem) {
    renderItem = function () {
      return null;
    };
  }
  var baseRef = useRef();
  var itemListRef = useRef();
  var visibleItemIdsRef = useRef([]);
  var handleResize = function () {
    if (hasFixedSizeItems) {
      var baseElm = baseRef.current;
      var item = baseElm.querySelector('li:first-child');
      var itemWidth = item.getBoundingClientRect().width;
      var baseElmWidth = baseElm.getBoundingClientRect().width;
      var peekWidthValue = remToPx(getValueOfToken(peekWidth));
      var mobileItemMarginPx = remToPx(getValueOfToken(mobileItemMargin));
      var pageWidth = (itemWidth + mobileItemMarginPx) * numOfVisibleItems + (peekWidthValue + mobileItemMarginPx / 2);

      /* istanbul ignore next */
      if (pageWidth < baseElmWidth) {
        baseElm.style.width = "".concat(pageWidth, "px");
      }
    }
  };

  /* istanbul ignore next */
  useEffect(function () {
    var resizeObserver;
    if (window.ResizeObserver) {
      var item = baseRef.current.querySelector('li:first-child');
      if (hasFixedSizeItems) {
        resizeObserver = new ResizeObserver(function () {
          handleResize();
        });
        resizeObserver.observe(item);
      }
    }
    return function () {
      if (resizeObserver) {
        resizeObserver.disconnect();
      }
    };
  }, []);

  /* istanbul ignore next */
  useEffect(function () {
    var itemObserver;
    handleResize();
    visibleItemIdsRef.current = [];
    if (window.IntersectionObserver) {
      var itemList = itemListRef.current;
      itemObserver = new IntersectionObserver(function (entries) {
        if (!visibleItemIdsRef.current.length) {
          var _iterator = _createForOfIteratorHelper(entries),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var entry = _step.value;
              if (entry.isIntersecting) {
                var id = entry.target.getAttribute('data-item-id');
                visibleItemIdsRef.current.push(id);
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          if (onInit) {
            onInit(visibleItemIdsRef.current);
          }
        } else {
          var _iterator2 = _createForOfIteratorHelper(entries),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var _entry = _step2.value;
              if (_entry.isIntersecting) {
                var _id = _entry.target.getAttribute('data-item-id');
                if (onItemListScroll) {
                  onItemListScroll(_id);
                }
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
      }, {
        root: baseRef.current,
        threshold: 1
      });
      var itemElms = itemList.querySelectorAll('li');
      itemElms.forEach(function (item) {
        return itemObserver.observe(item);
      });
    }
    return function () {
      if (itemObserver) {
        itemObserver.disconnect();
      }
    };
  }, [numOfVisibleItems, hasFixedSizeItems]);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: cx(className, styles.base),
    ref: baseRef,
    "data-ppui-info": "horizontal-scroll_3.2.3__8.12.0"
  }, rest), /*#__PURE__*/React.createElement(ItemList, {
    items: items,
    hasFixedSizeItems: hasFixedSizeItems,
    isMobileBreakpoint: true,
    numOfVisibleItems: numOfVisibleItems,
    renderItem: renderItem,
    itemClassName: itemClassName,
    ref: itemListRef,
    "data-ppui": "true"
  }));
};

var _excluded$1 = ["items", "hasFixedSizeItems", "isMobileBreakpoint", "itemClassName", "numOfVisibleItems", "renderItem"],
  _excluded2 = ["currentPage", "prevPageLabel", "nextPageLabel", "onPageChange"],
  _excluded3 = ["onItemListScroll", "onInit"];
var ItemList = forwardRef(function (props, ref) {
  var items = props.items;
    props.hasFixedSizeItems;
    props.isMobileBreakpoint;
    var itemClassName = props.itemClassName;
    props.numOfVisibleItems;
    var renderItem = props.renderItem,
    rest = _objectWithoutProperties(props, _excluded$1);

  /* istanbul ignore next */
  var handleFocus = function (evt) {
    evt.target.scrollIntoView({
      block: 'nearest'
    });
  };
  var itemElements = items.map(function (item, index) {
    var flexBasisStyles = getFlexBasisItems === null || getFlexBasisItems === void 0 ? void 0 : getFlexBasisItems(props);
    return /*#__PURE__*/React.createElement("li", {
      "aria-label": "".concat(index + 1, "-").concat(items.length),
      key: item.id,
      "data-item-id": item.id,
      style: flexBasisStyles,
      className: cx(itemClassName, styles.item),
      "data-ppui": "true"
    }, renderItem(item, {
      tabIndex: '0',
      role: 'button',
      onFocus: handleFocus
    }));
  });
  return /*#__PURE__*/React.createElement("ul", _extends({
    className: styles.itemList,
    ref: ref
  }, rest, {
    "data-ppui": "true"
  }), itemElements);
});
var HorizontalScroll = function (props) {
  /* istanbul ignore next */
  if (!props.items) {
    devWarning('Required prop `items` is missing');
  }

  /* istanbul ignore next */
  if (!props.renderItem) {
    devWarning('Required prop `renderItem` is missing');
  }
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showMobileHScroll = _useState2[0],
    setShowMobileHScroll = _useState2[1];
  var mdBreakpoint = remToPx(Number.parseInt(breakpoints.mediaMd.slice(0, -2))); // removing unit px to convert mediaMd breakpoint to number
  /* istanbul ignore next */
  useEffect(function () {
    var mql = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)');
    var hasHover = mql && mql.matches;
    setShowMobileHScroll(window.innerWidth < mdBreakpoint || window.matchMedia && !hasHover);
  }, []);
  if (showMobileHScroll) {
    props.currentPage;
      props.prevPageLabel;
      props.nextPageLabel;
      props.onPageChange;
      var _rest = _objectWithoutProperties(props, _excluded2);
    return /*#__PURE__*/React.createElement(HorizontalScrollMobile, _extends({}, _rest, {
      "data-ppui": "true"
    }));
  }
  props.onItemListScroll;
    props.onInit;
    var rest = _objectWithoutProperties(props, _excluded3);
  return /*#__PURE__*/React.createElement(HorizontalScrollDesktop, _extends({}, rest, {
    autoAdvance: props.autoAdvance,
    advanceInterval: props.advanceInterval,
    "data-ppui": "true"
  }));
};

var _excluded = ["items", "numOfVisibleItems", "renderItem", "className", "itemClassName", "prevButtonClassName", "nextButtonClassName", "prevPageLabel", "nextPageLabel", "currentPage", "hasFixedSizeItems", "autoAdvance", "advanceInterval", "onPageChange", "style"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Dots = function (_ref) {
  var numOfPages = _ref.numOfPages,
    currentPage = _ref.currentPage;
  var dotElements = [];
  for (var i = 1; i <= numOfPages; i++) {
    var dotStyles = [styles.dot, currentPage === i && styles.dotSelected];
    dotElements.push( /*#__PURE__*/React.createElement("div", {
      key: i,
      className: cx.apply(void 0, dotStyles),
      "data-ppui": "true"
    }));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: styles.dots,
    "aria-hidden": true,
    "data-ppui": "true"
  }, dotElements);
};

/*
 * Turns out that using setInterval() in react with hooks is awkward.
 * This method I lifted from Dan Abramov makes it easy to use in a
 * react hook-ish way.
 * Pass in a callback and a delay in ms or null to turn it off
 * --love, BCC
 */

/* istanbul ignore next */
function useInterval(callback, delay) {
  var savedCallback = useRef();

  // Remember the latest function.
  useLayoutEffect(function () {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useLayoutEffect(function () {
    function tick() {
      savedCallback.current();
    }
    if (delay !== null) {
      var id = setInterval(tick, delay);
      return function () {
        clearInterval(id);
      };
    }
    return undefined;
  }, [delay]);
}

/* (from the Jira spec)
  Auto-advance activates on a new page load.
  It will advance every 4 seconds by default, but the caller can specify a different timing.
  It will stop if the user scrolls the horizontal scroll out of view, interacts with cards, or clicks a button.
  It will also stop after 1 full cycle.
 */
var HorizontalScrollDesktop = function (_ref2) {
  var _ref2$items = _ref2.items,
    items = _ref2$items === void 0 ? [] : _ref2$items,
    _ref2$numOfVisibleIte = _ref2.numOfVisibleItems,
    numOfVisibleItems = _ref2$numOfVisibleIte === void 0 ? 1 : _ref2$numOfVisibleIte,
    renderItem = _ref2.renderItem,
    className = _ref2.className,
    itemClassName = _ref2.itemClassName,
    prevButtonClassName = _ref2.prevButtonClassName,
    nextButtonClassName = _ref2.nextButtonClassName,
    _ref2$prevPageLabel = _ref2.prevPageLabel,
    prevPageLabel = _ref2$prevPageLabel === void 0 ? 'Scroll left' : _ref2$prevPageLabel,
    _ref2$nextPageLabel = _ref2.nextPageLabel,
    nextPageLabel = _ref2$nextPageLabel === void 0 ? 'Scroll right' : _ref2$nextPageLabel,
    _ref2$currentPage = _ref2.currentPage,
    currentPage = _ref2$currentPage === void 0 ? 1 : _ref2$currentPage,
    hasFixedSizeItems = _ref2.hasFixedSizeItems,
    _ref2$autoAdvance = _ref2.autoAdvance,
    autoAdvance = _ref2$autoAdvance === void 0 ? false : _ref2$autoAdvance,
    _ref2$advanceInterval = _ref2.advanceInterval,
    advanceInterval = _ref2$advanceInterval === void 0 ? 4000 : _ref2$advanceInterval,
    onPageChange = _ref2.onPageChange,
    style = _ref2.style,
    rest = _objectWithoutProperties(_ref2, _excluded);
  /* istanbul ignore next */
  if (!renderItem) {
    renderItem = function () {
      return null;
    };
  }
  var baseRef = useRef(null);
  var scrollPanel = useRef(null);
  var pageContainerRef = useRef();
  var itemListRef = useRef();
  var _useState = useState(Math.ceil(items.length / numOfVisibleItems)),
    _useState2 = _slicedToArray(_useState, 2),
    numOfPages = _useState2[0],
    setNumOfPages = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isAutoAdvance = _useState4[0],
    setIsAutoAdvance = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isRTL = _useState6[0],
    setRTL = _useState6[1];
  var _useState7 = useState('0'),
    _useState8 = _slicedToArray(_useState7, 2),
    pageWidth = _useState8[0],
    setPageWidth = _useState8[1];
  var viewObserver = useRef(null);
  var hasBeenVisibleRef = useRef(false);
  var autoAdvanceComplete = useRef(false);

  /* istanbul ignore next */
  var handleResize = function () {
    var pageContainer = pageContainerRef.current;
    if (pageContainer) {
      if (hasFixedSizeItems) {
        var item = pageContainer.querySelector('li:first-child');
        var itemWidth = item.getBoundingClientRect().width;
        var newNumOfPages = Math.ceil(items.length / numOfVisibleItems);
        var itemMarginPx = remToPx(getValueOfToken(itemMargin));
        setPageWidth("".concat((itemWidth + itemMarginPx) * numOfVisibleItems));
        setNumOfPages(newNumOfPages);
        if (currentPage > newNumOfPages) {
          onPageChange(newNumOfPages);
        }
      } else {
        var itemList = itemListRef.current;
        // scrollwidth always returns a whole value, getBoundingClientRect().width sometimes returns value comparing
        // pageContainerWidth with scrollWidth when the width causes an overflow resulting in adding and extra page.
        // e.g. scrollWidth = 1201, vs pageContainerWidth = 1200.092
        var itemListScrollWidth = itemList === null || itemList === void 0 ? void 0 : itemList.scrollWidth;
        var pageContainerWidth = Math.ceil(pageContainer.getBoundingClientRect().width);
        if (itemListScrollWidth && pageContainerWidth) {
          var _newNumOfPages = Math.ceil(itemListScrollWidth / pageContainerWidth);
          setNumOfPages(_newNumOfPages);
          if (currentPage > _newNumOfPages) {
            onPageChange(_newNumOfPages);
          }
        }
        setPageWidth("".concat(pageContainerWidth));
      }
    }
  };

  /* istanbul ignore next */

  /* istanbul ignore next */
  var stopAutoAdvance = function () {
    setIsAutoAdvance(false);
    autoAdvanceComplete.current = true;
    // eslint-disable-next-line no-unused-expressions
    viewObserver && viewObserver.current && viewObserver.current.disconnect();
  };

  /* istanbul ignore next */

  /* istanbul ignore next */
  var handleIntersection = function (entries) {
    var _entries = _slicedToArray(entries, 1),
      entry = _entries[0];

    // No intersection between hscroll & viewport?
    // ...then we've scrolled off screen - stop auto advance

    if (!entry.isIntersecting) {
      if (hasBeenVisibleRef.current) {
        stopAutoAdvance();
      }
    } else if (autoAdvance && !hasBeenVisibleRef.current) {
      setIsAutoAdvance(!autoAdvanceComplete.current);
      hasBeenVisibleRef.current = true;
    }
  };

  /* istanbul ignore next */
  useEffect(function () {
    var computedStyle = window.getComputedStyle(baseRef.current);
    setRTL(computedStyle && computedStyle.direction === 'rtl');
    var resizeObserver;
    if (window.ResizeObserver && baseRef.current) {
      var item = baseRef.current.querySelector('li:first-child');
      resizeObserver = new ResizeObserver(function () {
        handleResize();
      });
      resizeObserver.observe(hasFixedSizeItems ? item : pageContainerRef.current);
    }
    return function () {
      if (resizeObserver) {
        resizeObserver.disconnect();
      }
    };
  }, []);
  useEffect(function () {
    /* istanbul ignore next */
    if (items.length && numOfVisibleItems) {
      window.requestAnimationFrame(handleResize);
    }
  }, [numOfVisibleItems, hasFixedSizeItems, items]);
  useEffect(function () {
    /* istanbul ignore next */
    setIsAutoAdvance(autoAdvance && hasBeenVisibleRef.current && !autoAdvanceComplete.current);
  }, [autoAdvance, hasBeenVisibleRef.current]);

  /* istanbul ignore next */
  useInterval(function handleAutoAdvance() {
    var nextPage = currentPage + 1;
    if (currentPage >= numOfPages) {
      // Have we reached the last page?
      stopAutoAdvance(); // We're done with auto advance
      var panel = scrollPanel.current;
      panel.style.transition = '0s linear';
      panel.style.left = '0px';
      setTimeout(function () {
        panel.style.transition = '';
      }, 100);
      nextPage = 1; // Go back to first page
    }
    onPageChange(nextPage);
  }, isAutoAdvance ? advanceInterval : null);
  useLayoutEffect(function () {
    /* istanbul ignore next */
    if (window && window.IntersectionObserver) {
      var hscroll = baseRef.current;
      if (autoAdvance && !autoAdvanceComplete.current) {
        viewObserver.current = new window.IntersectionObserver(handleIntersection);
        viewObserver.current.observe(hscroll);
      }
    }
  }, [autoAdvance, autoAdvanceComplete.current]);

  /* istanbul ignore next */
  useEffect(function () {
    if (!window.IntersectionObserver) {
      return undefined;
    }
    var hscroll = baseRef.current;
    var stopObserving = function () {
      if (viewObserver && viewObserver.current) {
        viewObserver.current.unobserve(hscroll);
      }
    };
    if (autoAdvance) {
      viewObserver.current.observe(hscroll);
    } else {
      stopObserving();
    }
    return stopObserving;
  }, [baseRef, autoAdvance]);

  /* istanbul ignore next */
  var renderPreviousButton = currentPage > 1 ? /*#__PURE__*/React.createElement("div", {
    className: styles.buttonPrevious,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement(IconButton, {
    buttonType: "secondary",
    inverse: true,
    svgIconComponent: isRTL ? ArrowRightIcon : ArrowLeftIcon,
    tabIndex: -1,
    "aria-hidden": true,
    onClick: function handlePrevClick() {
      onPageChange(currentPage - 1);
      setIsAutoAdvance(false);
    },
    onMouseDown: function onMouseDown(evt) {
      return evt.preventDefault();
    },
    className: prevButtonClassName,
    "data-ppui": "true"
  }, prevPageLabel)) : null;

  /* istanbul ignore next */
  var renderNextButton = currentPage < numOfPages ? /*#__PURE__*/React.createElement("div", {
    className: styles.buttonNext,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement(IconButton, {
    buttonType: "secondary",
    inverse: true,
    svgIconComponent: isRTL ? ArrowLeftIcon : ArrowRightIcon,
    tabIndex: -1,
    "aria-hidden": true,
    onClick: function handleNextClick() {
      onPageChange(currentPage + 1);
      setIsAutoAdvance(false);
    },
    onMouseDown: function onMouseDown(evt) {
      return evt.preventDefault();
    },
    className: nextButtonClassName,
    "data-ppui": "true"
  }, nextPageLabel)) : null;

  /* istanbul ignore next */
  var renderDots = numOfPages > 1 ? /*#__PURE__*/React.createElement(Dots, {
    numOfPages: numOfPages,
    currentPage: currentPage,
    "data-ppui": "true"
  }) : null;
  var pageOffset = -pageWidth * (currentPage - 1); // sliding being controll with this value

  /* istanbul ignore next */
  var pageStyle = isRTL ? {
    right: pageOffset
  } : {
    left: pageOffset
  };
  return /*#__PURE__*/React.createElement("div", _extends({
    className: cx(className, styles.base),
    ref: baseRef,
    onFocus: autoAdvance ? function handleFocus() {
      setIsAutoAdvance(false);
    } : null,
    style: _objectSpread(_objectSpread({}, style), getContainerWidth(pageWidth, hasFixedSizeItems)),
    "data-ppui-info": "horizontal-scroll_3.2.3__8.12.0"
  }, rest), /*#__PURE__*/React.createElement("div", {
    className: styles.pageContainer,
    ref: pageContainerRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.page,
    style: pageStyle,
    ref: scrollPanel,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement(ItemList, {
    items: items,
    hasFixedSizeItems: hasFixedSizeItems,
    isMobileBreakpoint: false,
    numOfVisibleItems: numOfVisibleItems,
    renderItem: renderItem,
    itemClassName: cx(itemClassName, styles.itemListDesktop),
    ref: itemListRef,
    className: cx(styles.itemList, styles.itemListDesktop),
    "data-ppui": "true"
  }))), renderPreviousButton, renderNextButton, renderDots);
};

export { HorizontalScroll, HorizontalScrollDesktop, HorizontalScrollMobile, ItemList };
